import React from 'react';
import { FaGithub, FaLinkedin } from 'react-icons/fa';

const EASE = 'cubic-bezier(0.4, 0, 0.2, 1)';
const T = `transform 0.4s ${EASE}, box-shadow 0.4s ${EASE}`;

const btnPrimary = {
  display: 'inline-flex', alignItems: 'center', gap: '8px',
  padding: '13px 28px', background: 'var(--accent)', color: '#FFFFFF',
  fontWeight: 600, fontSize: '0.88rem', border: 'none',
  borderRadius: '100px', cursor: 'pointer', textDecoration: 'none',
  transform: 'translateY(0)',
  transition: `${T}, background 0.3s ease`,
};
const btnGhost = {
  display: 'inline-flex', alignItems: 'center', gap: '8px',
  padding: '13px 28px', background: 'transparent', color: 'var(--text-primary)',
  fontWeight: 500, fontSize: '0.88rem',
  border: '1px solid var(--border-subtle)',
  borderRadius: '100px', cursor: 'pointer', textDecoration: 'none',
  transform: 'translateY(0)',
  transition: `${T}, border-color 0.3s ease, background 0.3s ease, color 0.3s ease`,
};

const onPrimaryIn = (e) => { e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.boxShadow = '0 8px 28px rgba(var(--accent-rgb),0.35)'; e.currentTarget.style.background = 'var(--accent-hover)'; };
const onPrimaryOut = (e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = 'none'; e.currentTarget.style.background = 'var(--accent)'; };
const onGhostIn = (e) => { e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.boxShadow = '0 6px 20px rgba(var(--accent-rgb),0.12)'; e.currentTarget.style.borderColor = 'var(--accent)'; e.currentTarget.style.background = 'var(--accent-soft)'; e.currentTarget.style.color = 'var(--accent)'; };
const onGhostOut = (e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = 'none'; e.currentTarget.style.borderColor = 'var(--border-subtle)'; e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = 'var(--text-primary)'; };

const About = () => {
  const stats = [
    { value: "3+", label: "Proyectos" },
    { value: "15+", label: "Tecnologías" },
    { value: "2+", label: "Años exp." },
  ];

  return (
    <section id="about" className="about-section">
      <div style={{ maxWidth: '1500px', margin: '0 auto', padding: '0 24px' }}>
        <div className="about-grid">
          <div className="about-visual reveal-left">
            <div className="about-image-frame">
              <img src="https://avatars.githubusercontent.com/u/102243922?v=4" alt="Andres Coronel" />
            </div>
            <div className="about-stats">
              {stats.map((stat, idx) => (
                <div key={idx} className="about-stat">
                  <div className="about-stat-value">{stat.value}</div>
                  <div className="about-stat-label">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="about-text reveal">
            <div className="section-label">Sobre mí</div>
            <h2>Creando el futuro, <span className="text-gradient">una línea de código a la vez</span></h2>
            <p>Soy un desarrollador de software apasionado por transformar ideas complejas en interfaces elegantes y funcionales que los usuarios aman usar.</p>
            <p>Mi enfoque combina la precisión técnica de bases de datos robustas como <strong>PostgreSQL</strong> y <strong>MongoDB</strong> con la interactividad fluida de frameworks modernos como <strong>Next.js</strong> y <strong>React</strong>.</p>
            <p>Siempre busco la excelencia — no solo en el código, sino en cada pixel de la experiencia de usuario.</p>
            <div className="about-actions">
              <a href="https://github.com/AndressCoronel" target="_blank" rel="noreferrer" style={btnPrimary} onMouseEnter={onPrimaryIn} onMouseLeave={onPrimaryOut}>
                <FaGithub size={17} /> GitHub
              </a>
              <a href="https://www.linkedin.com/in/andres-coronel-164767263/" target="_blank" rel="noreferrer" style={btnGhost} onMouseEnter={onGhostIn} onMouseLeave={onGhostOut}>
                <FaLinkedin size={17} /> LinkedIn
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
